import Vue from 'vue';
import App from './App.vue';
import router from './router';
import BootstrapVue from 'bootstrap-vue';
import VueSweetalert2 from 'vue-sweetalert2';
import store from './store';
import axios from 'axios';
import VueToast from 'vue-toast-notification';
import vTitle from 'vuejs-title';

import 'vue-toast-notification/dist/theme-default.css';
//import 'vue-toast-notification/dist/theme-sugar.css';

import moment from 'moment';

Vue.prototype.moment = moment;

const options = {
	confirmButtonColor: '#2563eb',
	cancelButtonColor: '#64748b',
};

Vue.use(BootstrapVue);
Vue.use(VueSweetalert2, options);
Vue.use(VueToast);
Vue.use(vTitle);

Vue.use(require('vue-moment'));

Vue.config.productionTip = process.env.NODE_ENV === 'production';

Vue.prototype.$http = axios;
const accessToken = localStorage.getItem('token');

Vue.filter('toCurrency', function(value) {
	if (typeof value !== 'number') {
		return value;
	}
	var formatter = new Intl.NumberFormat('de-DE', {
		style: 'currency',
		currency: 'EUR',
		minimumFractionDigits: 0,
	});
	return formatter.format(value);
});

if (accessToken) {
	Vue.prototype.$http.defaults.headers.common['x-access-token'] = accessToken;
}

//Vue.prototype.$uploadHostname = (Vue.config.productionTip) ? '/momentup' : 'http://'+Vue.config.subdomain+'.kindyapp.dd/momentup'
Vue.prototype.$apiBase = Vue.config.productionTip
	? 'https://kunden-bereich.kindy-app.de/api2024'
	: 'http://localhost:3005';
Vue.prototype.$socketBase = Vue.config.productionTip
	? 'https://adminarea.kindy.co'
	: 'http://localhost:3001';

Vue.prototype.$http.defaults.baseURL = Vue.prototype.$apiBase;

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
